import { z } from "zod";

import {
  addressSchema,
  instructionIdSchema,
  sortValues,
  transactionHashSchema,
} from "@schemas/misc";

/**
 * schemas
 */

export const transactionSchema = z.object({
  instructionId: instructionIdSchema,
  transactionHash: transactionHashSchema.optional(),
  blockHash: z.string().nullable(),
  transactionStatus: z.string(),
  error: z.string().nullish(),
  startedAt: z.string(),
  startedAtBlock: z.number(),
  finishedAt: z.string().nullable(),
  finishedAtBlock: z.number().nullable(),
  amount: z.object({ value: z.number(), token: z.string() }).nullish(),
  instructedValue: z.string(),
  instructedTokenAddress: z.string().nullable(),
  executionNum: z.number(),
});
export type Transaction = z.infer<typeof transactionSchema>;

export const transactionWithValidAmountSchema = transactionSchema.extend({
  amount: z.object({ value: z.number(), token: z.string() }),
});
export type TransactionWithValidAmount = z.infer<
  typeof transactionWithValidAmountSchema
>;

// api schemas

export const transactionGetListRequestSchema = z.object({
  address: addressSchema,
  chainId: z.number(),
  instructionIds: z.array(z.string()),
  from: z.string(),
  to: z.string(),
  skip: z.number(),
  take: z.number(),
  sort: z.enum(sortValues),
});
export type TransactionGetListRequest = z.infer<
  typeof transactionGetListRequestSchema
>;

export const transactionGetListResponseSchema = z.array(transactionSchema);
export type TransactionGetListResponse = z.infer<
  typeof transactionGetListResponseSchema
>;
